import { render } from "./WithoutRewardSection.vue?vue&type=template&id=2964fb07"
import script from "./WithoutRewardSection.vue?vue&type=script&lang=js"
export * from "./WithoutRewardSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__